import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  //we do not have such breakpoints, it is a temporary solution
  @media (min-width: 410px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 830px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
